import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './style.css';
import Home from './views/home';
import Register from './views/register';
import Basket from './views/basket';
import CampaignAllocation from './views/campaign-allocation';
import Test1 from './views/test1';
import StripeReturn from './views/stripereturn';
import StripeRefresh from './views/striperefresh';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/basket" element={<Basket />} />
        <Route path="/campaign-allocation" element={<CampaignAllocation />} />
        <Route path="/test1" element={<Test1 />} />
        <Route path="/stripereturn" element={<StripeReturn />} />
        <Route path="/striperefresh" element={<StripeRefresh />} />
      </Routes>
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById('app'));
